import { BUSINESS_UNITS, DIVISIONS } from './BusinessUnits';
import { SERVICES } from './Services';

const rootDomain = 'https://tracsis.com';

export const GLOBAL_NAVIGATION = [
	{
		label: DIVISIONS.RAIL.label,
		to: `${rootDomain}${DIVISIONS.RAIL.to}`,
		menu: [
			{
				label: SERVICES.OPS.label,
				menu: [
					BUSINESS_UNITS.RAIL,
					BUSINESS_UNITS.BELLVEDI,
					BUSINESS_UNITS.TRACSISUS_OP,
				],
			},

			{
				label: SERVICES.CX.label,
				menu: [BUSINESS_UNITS.IBLOCKS],
			},

			{
				label: SERVICES.DIGITALRAILWAY.label,
				menu: [
					BUSINESS_UNITS.MPEC,
					BUSINESS_UNITS.ONTRAC,
					BUSINESS_UNITS.TRACSISUS_DR,
				],
			},
		],
	},
	{
		label: DIVISIONS.DACE.label,
		to: `${rootDomain}${DIVISIONS.DACE.to}`,
		menu: [
			{
				label: SERVICES.TRAFFICDATA.label,
				menu: [BUSINESS_UNITS.TRAFFICDATA],
			},

			{
				label: SERVICES.ETM.label,
				menu: [BUSINESS_UNITS.EVENTS],
			},

			{
				label: SERVICES.DATAINFORMATICS.label,
				menu: [BUSINESS_UNITS.COMPASS, BUSINESS_UNITS.ICON],
			},
		],
	},
];

export const GLOBAL_NAVIGATION_SECONDARY = [
	{
		label: 'Tracsis Plc',
		to: `${rootDomain}`,
	},
	{
		label: 'Careers',
		to: `${rootDomain}/careers`,
	},
	{
		label: 'Investors',
		to: `${rootDomain}/investors`,
	},
];
